"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchEmailDefaultSubscription = fetchEmailDefaultSubscription;
exports.getEmailSubscriptionsRequestState = exports.fetchEmailSubscriptions = void 0;

var fetchEmailSubscriptions = function fetchEmailSubscriptions(state) {
  return state.emailSubscriptions.emailSubscriptionsList;
};

exports.fetchEmailSubscriptions = fetchEmailSubscriptions;

function fetchEmailDefaultSubscription(state) {
  var emailSubscriptions = fetchEmailSubscriptions(state);

  if (emailSubscriptions.length < 1) {
    return null;
  }

  return (emailSubscriptions.find(function (s) {
    return s.name === 'Marketing Information';
  }) || emailSubscriptions[0]).id;
}

var getEmailSubscriptionsRequestState = function getEmailSubscriptionsRequestState(state) {
  return state.emailSubscriptions.fetchRequestState;
};

exports.getEmailSubscriptionsRequestState = getEmailSubscriptionsRequestState;